import { StatTableNumberColumn } from "components/StatsTable/Columns/Number/NumberColumn";
import { StatTableColumn } from "components/StatsTable/StatTableColumn";
import { TimeAttackRecordWithDisplay } from "model/Records old/TimeAttackRecord";
import { positionNumberToText } from "Utility";

export const getTimeAttackRecordOverviewStatTableColumns = (
  trackNames: (string | undefined)[],
  groups?: { startPosition: number; endPosition: number; color: string }[]
): StatTableColumn<TimeAttackRecordWithDisplay>[] => {
  return [
    {
      type: "Position",
      sortable: true,
      positionGetter: (arg) => arg.record.position,
      accentGetter: !!groups
        ? (arg) =>
            groups.find(
              (g) =>
                arg.record.position >= g.startPosition &&
                arg.record.position <= g.endPosition
            )?.color
        : undefined,
    },
    {
      type: "OrgLogoName",
      sortable: true,
      orgIdGetter: (arg) => arg.orgId,
      nameGetter: (arg) => arg.displayName,
      smallerSize: true,
    },
    {
      type: "Number",
      header: "Avg Rank",
      sortable: true,
      valueGetter: (arg) =>
        !!arg.record.avgTrackRank ? arg.record.avgTrackRank : undefined,
      subTextGetter: (arg) =>
        !!arg.record.totalScore
          ? (arg.record.totalScore! / 1000).toFixed(3)
          : undefined,
      fractionDigits: 1,
      highlight: true,
    },
    ...trackNames.map((name, idx) => {
      const column: StatTableNumberColumn<TimeAttackRecordWithDisplay> = {
        type: "Number",
        header: name ?? "-",
        sortable: !!name,
        valueGetter: (arg) =>
          !!arg.record.tracks[idx].score
            ? arg.record.tracks[idx].score! / 1000
            : undefined,
        fractionDigits: 3,
        subTextGetter: (arg) =>
          !!arg.record.tracks[idx].rank
            ? positionNumberToText(arg.record.tracks[idx]!.rank!)
            : undefined,
      };

      return column;
    }),
  ];
};
